export default __webpack_public_path__ + "static/media/dna1.64585d36.png";